var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchResult = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18a8.96 8.96 0 0 0 5.633-1.992l7.658 7.697a1 1 0 0 0 1.418-1.411l-7.668-7.707A8.94 8.94 0 0 0 18 9c0-4.963-4.037-9-9-9S0 4.037 0 9c0 4.962 4.037 9 9 9M9 2c3.859 0 7 3.14 7 7s-3.141 7-7 7-7-3.141-7-7 3.14-7 7-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.75 5.865-3.02 1.86-2.56-2.046c-.458-.366-.956-.35-1.267.04l-.594.743c-.315.393-.224.916.22 1.271l4.028 3.217-.846.019a1.01 1.01 0 0 0-.78.386l-.397.516a.97.97 0 0 0 .586 1.56l5.01.86c.347.062.7-.07.918-.344l2.62-3.279c.244-.305.279-.724.058-1.113l-2.806-3.52a.3.3 0 0 0-.052-.051c-.361-.289-.804-.332-1.117-.118z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchResult.svg";